import { LCDocumentEditorUtils } from './LCDocumentEditorUtils';
import { LCDocumentEditor } from './LCDocumentEditor';
import { LectioJSUtils } from './../LectioJSUtils';
import { ILectioPlugin } from './Types';
import { LCDialogEditorUtils } from './LCEditorDialogUtils';

export class PluginLectioContent implements ILectioPlugin {
	public Init(): void {
		CKEDITOR.plugins.add('lectiocontent', {
			init: (editorOuter: CKEDITOR.editor) => {
				const config = LCDocumentEditorUtils.GetEditorConfig(editorOuter);

				let exec_lectiomateriale: ((editor: CKEDITOR.editor) => true) | null;
				if (config.showHomeworkPicker) {
					const showhp = config.showHomeworkPicker;
					const handleSelection = config.handleHomeworkPickerSelection;
					exec_lectiomateriale = editor => {
						const hadFocus = LCDocumentEditor.GetEditorLectioState(editor).getWasFocusInEditorBeforeCommand();
						showhp({
							supportsHomeworkCreationMannerOptions: true,
							homeworkCreationOptionAktuelleAfsnit: hadFocus ? 'visible' : 'disabled',
							defaultHomeworkCreationManner: LectioJSUtils.GetNotNullValue(config.homeworkType)
						}).then(selection => {
							if (!selection)
								return;

							LCDialogEditorUtils.ProcessNewHomeworkSelection(
								editor, selection, handleSelection, hadFocus);
						});
						return true;
					}
				}
				else
					exec_lectiomateriale = null;

				if (exec_lectiomateriale) {
					editorOuter.addCommand("LectioMateriale", {
						editorFocus: false,
						exec: exec_lectiomateriale
					});
					editorOuter.ui.addButton('LectioMateriale', {
						label: "Vælg materiale",
						command: 'LectioMateriale',
						icon: '/lectio/img/add16x16.auto',
						toolbar: ''
					});
				}

				if (config.assistedCommand) {
					editorOuter.addCommand("LectioFritekst", {
						exec: editor => {
							config.assistedCommand("nyfritekst");
							return true;
						}
					});
					editorOuter.addCommand("LectioQuiz", {
						exec: editor => {
							config.assistedCommand("nyquiz");
							return true;
						}
					});

					editorOuter.ui.addButton('LectioFritekst', {
						label: "Nyt tomt afsnit",
						command: 'LectioFritekst',
						icon: '/lectio/img/emptydoc.auto',
						toolbar: ''
					});
					editorOuter.ui.addButton('LectioQuiz', {
						label: "Opret ny quiz",
						command: 'LectioQuiz',
						icon: '/lectio/img/questionnaire.auto',
						toolbar: ''
					});
				}
			}
		});
	}
}
